export * from "./accomplishments.component";
